import moment from 'moment';
import { WorkflowNotifications } from '../../Enums/WorkflowNotifications';

export const NotificationType = Object.freeze({
    STOP_OWNER: 0,
});

export const defaultNotificationTemplates = {
    stopOwner: {
        type: NotificationType.STOP_OWNER,
        templateId: null,
    }
};

const defaultWorkflowNotifications = Object.keys(WorkflowNotifications).map(x => ({
    type: WorkflowNotifications[x],
    templateId: null,
    timeValue: 1,
    timeUnit: 0,
}))


export const getDefaultAdminValues = (props) => ({
    schedulePeriod: {
        firstDayOfWeek: 0
    },
    columnSet: {
        dataview: '',
        columnSetSort: 'dataviewDefaultSort',
        columnSetOrder: 'unassignedLineOnTop',
        dataviewDual: [],
        visibleColumns: []
    },

    workplanTemplateOptions: {
        scheduleRule: '',
        usePatternTemplate: true,
        createPatternTemplate: false,
        orgPathMode: 'singleOrgPath',
        modifyTemplate: true,
        pauseTemplate: false,
        stopTemplate: false
    },
    coverage: {
        enableCountByShiftSet: true,
        enableCountByZone: false,
        shiftSet: '',
        zoneSet: '',
        isEnabledWorkplanCoverage: false,
        isEnabledShiftlineCoverage: false,
        pushCoverageRolloutWorkplan: null,
        pushCoverageEditRolloutWorkplan: null,
        pushCoveragePauseWorkplan: null,
        pushCoverageEditPauseWorkplan: null,
        pushCoverageStopWorkplan: null,
        pushCoverageAddShiftline: null,
        pushCoveragePauseShiftline: null,
        pushCoverageStopShiftline: null,
        enableSystemCoverage: false,
        allowReadBaseline: false,
        allowReadPlanned: false,
        bottomPanel: 'defaultViewByShift',
        showCoverageByLine: true
    },
    shiftHours: {
        enableTotalYearCalculation: true,
        yearType: 'weeks',
        yearTotalColumn: '',
        effectiveDateForYearCalculation: moment(),
        yearDuration: 52,
        shiftTemplates: []
    },
    employeeAssignement: {
        allowToEdit: false,
        allowToStop: false,
        allowToPause: false,
        enableAutoStopTerminated: false,
        enableAutoPauseInactive: false,
        enableAutoPauseWithPayCode: false,
        paycodes: []
    },
    shiftLineOptions: {
        allowAddNew: false,
        allowEdit: false,
        allowDelete: false
    },
    warning: {
        requiredSkillsCheck: false,
        requiredCertificationsCheck: false,
        expiredCertificationsCheck: false,
        overlappingEmployeesCheck: false,
        overlappingOnDifferentWorkplansCheck: false
    },
    shiftBiddingIntegration: {
        enableShiftBiddingIntegration: false,
        allowOwnerToBeAssignedToConcurentWorkplan: false,
    },
    importation: {
        allowCSVImport: false,
        allowSchedulePatternTemplateOverride: false,
        availabilityTemplateType: null,
        scheduleTagId: null
    },
    dataVisibility: {
        weeklyHours: false,
        weeklyHoursByDefault: false,
    },
    notifications: { ...defaultNotificationTemplates },
    workflowNotifications: defaultWorkflowNotifications,
})